// @ts-nocheck

import { type StateType } from '../states/index';
import { CardModes } from '../types/common';
import { type CardMode } from '../types/common';
import { MarketIds } from '../types/market';
import { type Selector } from '../types/selectors';
import { type SelectorMaker } from '../types/selectors';
import { createResultEqualSelector } from '../utils/reselect';

import {
  selectEntitiesBetsEntity,
  selectEntitiesBetsEntityOutcomes,
} from './entities/bets/entitiesBetsPrimary.selector';
import { type EntitiesBetsSelectorProps } from './entities/bets/entitiesBetsPrimary.selector';
import { selectEntitiesOutcomes } from './entities/outcomes/entitiesOutcomesPrimary.selector';

// no-memoize
export const selectBetBoostedOddCardMode: Selector<CardMode> = (
  state: StateType,
  props?: EntitiesBetsSelectorProps,
) => {
  const bet = selectEntitiesBetsEntity(state, props);

  if (bet?.marketId === MarketIds.MARKET_ID_BOOSTED_BET) {
    return CardModes.BOOSTED;
  }

  if (bet?.marketId === MarketIds.MARKET_ID_BIG_BOOSTED_BET) {
    return CardModes.BIG_BOOSTED;
  }

  if (bet?.marketId === MarketIds.MARKET_ID_XMAS_BOOSTED_BET) {
    return CardModes.XMAS_BOOSTED;
  }

  return CardModes.NORMAL;
};

export const makeBetHotOutcomeIdsSelector: SelectorMaker<Array<number>> = () => {
  const emptyArray: [] = [];

  return createResultEqualSelector(
    [selectEntitiesBetsEntityOutcomes, selectEntitiesOutcomes],
    (betOutcomeIds, outcomesMap) =>
      betOutcomeIds?.filter((outcomeId) => outcomesMap[outcomeId]?.hotUsers) ?? emptyArray,
  );
};
